module.exports = __webpack_public_path__ + "img/y-fpgh-bg.26b9a446.png";